import {
    nullableNumber,
    nullableNumberAtleastZero,
    nullableString,
    requiredNumberAtleastZero,
    requiredString,
} from "common";
import { CatalogItemObject, MerchandiseCatalogItem, MerchandiseCatalogItemStatus, OversellPolicy } from "types";
import { object } from "yup";
import { getSeller } from "@/utils/getSeller";

export interface VariantFormValues {
    price: number | undefined;
    strikeThroughPrice: number;
    hasStrikeThroughPrice: boolean;
    sku: string;
    barcode: string;
    trackQuantity: boolean;
    oversellPolicy?: OversellPolicy;
    notifyLowInventory: boolean;
    lowInventoryThreshold: number;
    status: MerchandiseCatalogItemStatus;
}

export const validationSchema = object().shape({
    price: requiredNumberAtleastZero(),
    strikeThroughPrice: nullableNumberAtleastZero(),
    sku: requiredString(),
    barcode: nullableString(),
    quantity: nullableNumber(),
    lowInventoryThreshold: nullableNumber(),
});

export const getInitialValues = (
    catalogItem: MerchandiseCatalogItem,
    isTrackQuantityEnabled: boolean,
): VariantFormValues => ({
    price: catalogItem.prices?.perUnit?.price,
    strikeThroughPrice: catalogItem.strikeThroughPrice ?? 0,
    hasStrikeThroughPrice: !!catalogItem.strikeThroughPrice,
    sku: catalogItem.sku ?? "",
    barcode: catalogItem.barcode ?? "",
    trackQuantity: isTrackQuantityEnabled,
    oversellPolicy: catalogItem.oversellPolicy,
    notifyLowInventory: !!catalogItem.lowInventoryThreshold,
    lowInventoryThreshold: catalogItem.lowInventoryThreshold ?? 0,
    status:
        catalogItem.status === MerchandiseCatalogItemStatus.PUBLISHED
            ? MerchandiseCatalogItemStatus.PUBLISHED
            : MerchandiseCatalogItemStatus.DRAFT,
});

export const getPayload = (
    values: VariantFormValues,
    merchandiseId: string,
    initialStatus: MerchandiseCatalogItemStatus,
) => ({
    object: CatalogItemObject.WARE_CATALOG_ITEM,
    product: { id: merchandiseId },
    seller: { id: getSeller().id },
    sku: values.sku ?? "",
    barcode: values.barcode,
    pricePerUnit: {
        price: Number(values.price),
    },
    strikeThroughPrice: values.hasStrikeThroughPrice ? Number(values.strikeThroughPrice) : undefined,
    ...(values.status !== initialStatus ? { status: values.status } : undefined),
    ...(values.trackQuantity
        ? {
              oversellPolicy: values.oversellPolicy ?? OversellPolicy.REQUIRE_AVAILABILITY,
              lowInventoryThreshold: values.notifyLowInventory ? Number(values.lowInventoryThreshold) : null,
          }
        : undefined),
});
